import { MdChecklist } from "react-icons/md";
import { defineType, defineField } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "suiteClassInclusionCategory",
  title: "Suite Class Inclusion Category",
  type: "document",
  icon: MdChecklist,
  preview: {
    select: { title: "title" },
    prepare: ({ title }) => ({
      title: multilingualStringPreview(title)
    })
  },
  fields: [
    defineField({
      name: "title",
      title: "Title",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    })
  ]
});
